import React, { useState } from 'react';
import { Button, message, Steps, theme, notification, Form } from 'antd';
import ProjectUpdate from '../ProjectUpdate'
import UploadMap from '../UploadMap'
import UploadFile from '../UploadFile'
import { useApp } from '../../../model';
import { useNavigate } from 'react-router-dom';
import { addProject, addProjectUsers } from '../../../api/project';
import { Dayjs } from 'dayjs';
import { uploadFile } from '../../../api/project';
import { batchImportDevices } from '../../../api/device';
const App: React.FC = () => {
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const {currentUserId} = useApp()

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const [basicInfoForm] = Form.useForm();
  const [formValues, setFormValues] = useState<ProjectFormValue>();
  const [imgFile, setImgFile] = useState();
  const [deviceListFile, setDeviceListFile] = useState();

  const steps = [
    {
      name: 'basic',
      title: <div>填写展会信息 <span style={{ color: '#ff4d4f' }}>*</span></div>,
      content: <div style={{ padding: 20 }}>
        <ProjectUpdate form={basicInfoForm} initialValues={{ is5G: true }} />
      </div>
    },
    {
      name: 'map',
      title: '上传平面图',
      content: <UploadMap onFileChange={setImgFile} />
    },
    {
      name: 'devices',
      title: '上传用电设备表',
      content: <UploadFile onFileChange={setDeviceListFile} />
    },
  ];

  const items = steps.map((item) => ({ key: item.title, title: item.title }));

  const contentStyle: React.CSSProperties = {
    lineHeight: '260px',
    textAlign: 'center',
    color: token.colorTextTertiary,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
    marginTop: 16,
  };

  const app = useApp();
  const nav = useNavigate();

  const uploadImgFile = (projectId: number, imgFile: any) => {
    const formData = new FormData();
    formData.append('file', imgFile as any)
    return uploadFile({ projectId }, formData)
  }
  const uploadDevices = (projectId: number, file: any) => {
    const formData = new FormData();
    formData.append('file', file as any)
    return batchImportDevices(projectId, formData)
  }

  const createProject = async (formValues: ProjectFormValue) => {
    const payload = {
      ...formValues,
      startDate: (formValues.startDate as Dayjs).format('YYYY-MM-DD'),
      endDate: (formValues.endDate as Dayjs).format('YYYY-MM-DD'),
    }
    app.setState('loading', true)
    try {
      const res = await addProject(payload);
      const users = payload.users;
      if(users?.length){
        await addProjectUsers(res.projectId, users)
      }
      if (imgFile) {
        await uploadImgFile(res.projectId, imgFile)
      }
      if (deviceListFile) {
        await uploadDevices(res.projectId, deviceListFile)
      }
      notification.success({ message: '创建成功' })
      nav('/project/' + res.projectId)
      app.setState('loading', false)
    } catch (err: any) {
      app.setState('loading', false)
      notification.error({ message: err?.message || '创建失败,请重试' })
    }
  }

  return (
    <>
      <Steps current={current} items={items} />
      <div style={contentStyle}>{steps[current].content}</div>
      <div style={{ marginTop: 24, display: 'flex', justifyContent: 'space-between' }}>
        <div>
          {current < steps.length - 1 && (
            <Button type="primary" onClick={() => {
              if (steps[current].name === 'basic') {
                basicInfoForm.validateFields()
                  .then(values => {
                    setFormValues(values)
                    next()
                  })
                  .catch(console.error)
              } else {
                next()
              }
            }}>
              下一步
            </Button>
          )}
          {current === steps.length - 1 ? (
            <Button disabled={!formValues} type="primary" onClick={() => {
              createProject(formValues!)
            }}>
              完成
            </Button>
          ) :
            null
          }
          {current > 0 && (
            <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
              上一步
            </Button>
          )}
        </div>
        <div>
          {
            current !== steps.length - 1 &&
            <Button type='primary' onClick={() => {
              if (formValues) {
                createProject(formValues)
              } else {
                basicInfoForm.validateFields()
                  .then(values => {
                    createProject(values)
                  })
                  .catch(console.error)
              }
            }}>
              立即创建 (跳过剩余步骤)
            </Button>
          }
        </div>
      </div>
    </>
  );
};

export default App;